var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Product.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-01c4bcd2\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Product.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/marketplace/amazon/provide/report/Product.vue
// module id = 2304
// module chunks = 0